import { Component, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { DataViewModule } from 'primeng/dataview';
import { TabViewModule } from 'primeng/tabview';
import { TableModule } from 'primeng/table';
import { ImageModule } from 'primeng/image';
import { MedicalState } from '../../../state/medical/medical-state';
import { AsyncPipe, CommonModule, NgFor, NgIf } from '@angular/common';
import { FileUploadHandlerEvent, FileUploadModule } from "primeng/fileupload";
import { MedicalService } from '../../../services/medical.service';
import { DraftMedicalBillComponent } from '../draft-medical-bill/draft-medical-bill.component';
import { CardModule } from 'primeng/card';
import { MedicalBillComponent } from '../medical-bill/medical-bill.component';
import { LockedRepricedBillComponent } from "../locked-repriced-bill/locked-repriced-bill.component";
import { MedicalBillSubmission } from '../../../models/medical-bill';
import { UtilService } from '../../../services/util.service';


@Component({
  selector: 'lib-medical-bill-processor',
  standalone: true,
  imports: [DataViewModule, TabViewModule, TableModule, AsyncPipe, NgFor, FileUploadModule,
    NgIf, ImageModule, DraftMedicalBillComponent, CardModule, MedicalBillComponent, CommonModule, LockedRepricedBillComponent],
  templateUrl: './medical-bill-processor.component.html',
  styleUrl: './medical-bill-processor.component.scss'
})
export class MedicalBillProcessorComponent implements OnInit
{

  submittedBills$ = this._store.select(MedicalState.submittedMedicalBills);
  unconfirmedSubmissions$ = this._store.select(MedicalState.completeUnconfirmedSubmissions);
  confirmedBills$ = this._store.select(MedicalState.confirmedMedicalBills);
  lockedBills$ = this._store.select(MedicalState.lockedRepricedBills);
  

  constructor
  (
    private _store:Store,
    private _medicalService:MedicalService,
    private _util: UtilService
  )
  {

  }
  ngOnInit(): void 
  {
  }

  async uploadFiles(event:FileUploadHandlerEvent, fileUpload:any)
  {
    //For Each file, upload the bill
    var files: File[] = event.files;
    files.forEach
    (
      async f => 
      {
        var submission = await this._medicalService.submitMedicalBill(f,false) as MedicalBillSubmission;
        //Load the thumbnail image

        //Set up the selector for this submission to get status updates
        // this.submissionStatusSelectors[submission.id] = this._store.select(MedicalState.submissionState).pipe(map(f => f(submission.id)))
        // this.submissionThumbnailSelectors[submission.id] = this._store.select(MedicalState.submissionThumbnail).pipe(map(f => f(submission.id)))

      }
    );

    //Clear the file queue
    fileUpload.clear();

    // if(this.uploader)
    // {
    //   var files: FileUpload[] = event.files;
    //   files.forEach(f => f.fileType = this.getFileType(f));
    //   var newFiles = await this.uploader.uploadFiles(files);
    //   this.modified.emit([...this.files, ...newFiles]);
    // }
  }



}
